import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class PotentialInformationAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getFundingOptions(router) {
    const url = "/api/potentialInformation/fundingOptions";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getMedicalStatusOptions(router) {
    const url = "/api/potentialInformation/medicalStatusOptions";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getShirtSizeOptions(router) {
    const url = "/api/potentialInformation/shirtSizeOptions";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getSourceOptions(router) {
    const url = "/api/potentialInformation/sourceOptions";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getProgramOptions(router) {
    const url = "/api/potentialInformation/programOptions";
    return this.CommonAPIService.getCall(url, "", router);
  }
}

export default PotentialInformationAPIService;
